import React from 'react';

export default function ServiceMainText({children}) {
  return <p className="service-main-text">{children}</p>;
}
